import React, { Fragment } from 'react';
import {
    Segment,
    Table,
    Header,
    Form,
    Button,
    Select,
    Input,
    Icon,
    Popup
} from 'semantic-ui-react';
import { FiltersOnStyle, IconHeader } from '../util/css';
import { FormattedMessage } from 'react-intl';

export default class ContactFormSegment extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            contacts: [],
            deletingRowId: null,
            saving: false,
            value: null,
            contactType: null,
            comment: null,
            valueError: false,
            contactTypeError: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.onAddNewContact = this.onAddNewContact.bind(this);
        this.getContacts = this.getContacts.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleConfirmClick = this.handleConfirmClick.bind(this);
    }

    componentDidMount() {
        this.getContacts();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ contacts: nextProps.contacts });
    }

    getContacts() {
        const { contacts } = this.props;
        this.setState({ contacts });
    }

    onAddNewContact() {
        const {
            value,
            contactType
        } = this.state;

        if ((value === null || value === '') || contactType === null) {
            this.setState({
                valueError: value === null || value === '',
                contactTypeError: contactType === null,
            });
            return;
        }

        const contact = {
            value: this.state.value,
            contactType: { id: this.state.contactType },
            comment: this.state.comment,
        };

        this.setState({ saving: true }, () => {
            this.props.onAddNewContact(contact)
                .then(() => {
                    this.setState({ saving: false });
                    this.props.switchEditMode();
                    this.resetValues();
                })
                .catch(() => {
                    this.setState({ saving: false });
                });
        });
    }

    resetValues() {
        this.setState({
            value: '',
            contactType: null,
            comment: null,
            valueError: false,
            contactTypeError: false,
        });
    }

    handleInputChange(e, {
        name,
        value
    }) {
        this.setState({ [name]: value });
    }

    handleDeleteClick(id) {
        this.setState({ deletingRowId: id });
    }

    handleCancelClick() {
        this.setState({ deletingRowId: null });
    }

    handleConfirmClick() {
        const { deletingRowId } = this.state;
        this.setState({ saving: true }, () => {
            this.props.onDeleteContact(deletingRowId)
                .then(() => {
                    this.setState({
                        deletingRowId: null,
                        saving: false
                    });
                })
                .catch(() => {
                    this.setState({ saving: false });
                });
        });
    }

    render() {
        const {
            contacts,
            deletingRowId,
            saving
        } = this.state;
        const {
            editMode,
            onClose,
            switchEditMode
        } = this.props;

        return (
            <Fragment>
                {/*!!contacts.length &&*/ (
                    <Segment clearing>
                        <Header style={IconHeader} floated="right">
                            <Popup
                                trigger={
                                    <Icon
                                        link
                                        size="mini"
                                        circular
                                        name="close"
                                        onClick={onClose}
                                        style={FiltersOnStyle}
                                    />
                                }
                                content="Zatvori"
                                hideOnScroll
                                position="top center"
                            />
                        </Header>
                        <Table compact size="small" celled verticalAlign={'middle'}>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                    <Table.HeaderCell>Tip</Table.HeaderCell>
                                    <Table.HeaderCell>Kontakt</Table.HeaderCell>
                                    <Table.HeaderCell textAlign={'center'} width={1}>
                                        {
                                            <Popup
                                                content={<FormattedMessage id="externalStudent.add"/>}
                                                position="top center"
                                                trigger={<Button
                                                    basic
                                                    circular
                                                    icon
                                                    size="tiny"
                                                    color="blue"
                                                    disabled={editMode || !!deletingRowId}
                                                    onClick={switchEditMode}
                                                >
                                                    <Icon name="plus"/>
                                                </Button>}/>
                                        }
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {contacts.map((el, index) => (
                                    <Table.Row key={el.id}>
                                        <Table.Cell width={1}>{index + 1}.</Table.Cell>
                                        <Table.Cell>
                                            {!!el.contactType && el.contactType.name}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {el.value}
                                        </Table.Cell>
                                        <Table.Cell textAlign={'center'} width={1}>
                                            {deletingRowId === el.id
                                                ?
                                                <Fragment>
                                                    <Popup
                                                        content="Potvrdi"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                circular
                                                                icon
                                                                size="tiny"
                                                                color="blue"
                                                                onClick={this.handleConfirmClick}
                                                                disabled={saving}
                                                                loading={saving}
                                                            >
                                                                <Icon name="check"/>
                                                            </Button>
                                                        }
                                                    />
                                                    <Popup
                                                        content="Otkaži"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                basic
                                                                circular
                                                                icon
                                                                size="tiny"
                                                                color="blue"
                                                                onClick={this.handleCancelClick}
                                                                disabled={saving}
                                                            >
                                                                <Icon name="close"/>
                                                            </Button>
                                                        }
                                                    />
                                                </Fragment>
                                                :
                                                <Popup
                                                    content="Brisanje"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            disabled={editMode || (deletingRowId && deletingRowId !== el.id)}
                                                            basic="true"
                                                            circular
                                                            icon="trash alternate"
                                                            size="tiny"
                                                            color="red"
                                                            onClick={() => {
                                                                this.handleDeleteClick(el.id);
                                                            }}
                                                        />
                                                    }
                                                />
                                            }
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    </Segment>
                )}

                {editMode && (
                    <Segment secondary clearing>
                        <Header as="h5">Dodaj novi kontakt</Header>
                        <Form noValidate>
                            <Form.Group widths="equal">
                                <Form.Field
                                    control={Select}
                                    clearable
                                    value={this.state.contactType}
                                    options={this.props.contactTypes}
                                    placeholder="Tip kontakta"
                                    onChange={this.handleInputChange}
                                    name="contactType"
                                    required
                                    error={this.state.contactTypeError}
                                />
                                <Form.Field
                                    control={Input}
                                    onChange={this.handleInputChange}
                                    placeholder="Vrijednost"
                                    value={this.state.value || ''}
                                    name="value"
                                    required
                                    error={this.state.valueError}
                                />
                            </Form.Group>
                            <Button basic color={'blue'} floated="right" onClick={switchEditMode} disabled={saving}>
                                Odustani
                            </Button>
                            <Button color={'blue'} floated="right" loading={saving} disabled={saving}
                                    onClick={this.onAddNewContact}>
                                Sačuvaj
                            </Button>
                        </Form>
                    </Segment>
                )}
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Assets/Leaseholder/LeaseholderContactForm.js